import { type FunctionalComponent, h } from '@stencil/core';
import { ConversationalSearchMessagesSuggestions } from '../suggestions';
import { ConversationalSearchMessagesSuggestionsOutro } from '../suggestions-card-outro/suggestions-card-outro';
import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';
import type { ConversationalSearchProductHierarchy, ConversationalSearchProductSuggestions } from '../../../../conversational-search-types/conversational-search-types.type';

export interface IConversationalSearchMessagesSuggestionsWrapper {
  hierarchy: ConversationalSearchProductHierarchy;
  suggestions: ConversationalSearchProductSuggestions[];
  labelProvider: labelProviderInterface;
  query: string;
  conversationalSearchBrandUrl: string;
  country: string;
  language: string;
  isBannerVariant?: boolean;
}

export const ConversationalSearchMessagesSuggestionsWrapper: FunctionalComponent<
  IConversationalSearchMessagesSuggestionsWrapper
> = (props) => {
    return (
      <section>
        <ConversationalSearchMessagesSuggestions
          labelProvider={(e, f) => props.labelProvider(e, f)}
          hierarchy={props.hierarchy}
          suggestions={props.suggestions}
          query={props.query}
          language={props.language}
          country={props.country}
        />
        <ConversationalSearchMessagesSuggestionsOutro
          labelProvider={(e, f) => props.labelProvider(e, f)}
          suggestions={props.suggestions}
          query={props.query}
          conversationalSearchBrandUrl={props.conversationalSearchBrandUrl}
          country={props.country}
          language={props.language}
        />
      </section>
    );
};
